module.exports = __webpack_public_path__ + "media/Radical_Transpaency_R2.5f34a654.mp4";